module.exports = __webpack_public_path__ + "img/13.d024be46.jpg";